import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handleCurrentTabClick = this.handleCurrentTabClick.bind(this)
    this.element.addEventListener("click", this.handleCurrentTabClick, true)

    this.processLinks()
    
    // Observe for new links added dynamically
    this.observer = new MutationObserver((mutations) => {
      let shouldProcess = false
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          shouldProcess = true
        }
      })
      
      if (shouldProcess) {
        this.processLinks()
      }
    })
    
    this.observer.observe(this.element, {
      childList: true,
      subtree: true
    })
  }

  disconnect() {
    this.element.removeEventListener("click", this.handleCurrentTabClick, true)

    if (this.observer) {
      this.observer.disconnect()
    }
  }

  handleCurrentTabClick(event) {
    const link = event.target.closest("a[data-external-link-current-tab]")

    if (!link || !this.element.contains(link) || !this.isExternal(link)) return

    event.preventDefault()
    window.location.assign(link.href)
  }

  processLinks() {
    this.element.querySelectorAll('a:not([target])').forEach(link => {
      if (this.isExternal(link)) {
        link.setAttribute('target', '_blank')
        // Add rel="noopener noreferrer" for security/performance with target="_blank"
        // Only add if not present to avoid overwriting specific needs (though usually fine to append)
        const currentRel = link.getAttribute('rel') || ''
        if (!currentRel.includes('noopener')) {
           link.setAttribute('rel', (currentRel + ' noopener noreferrer').trim())
        }
      }
    })
  }

  isExternal(link) {
    if (!link.href) return false
    
    try {
      const url = new URL(link.href)
      
      // Only handle http/https links
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return false
      
      // Compare hostnames
      return url.hostname !== window.location.hostname
    } catch (e) {
      return false
    }
  }
}
